import {$host} from "./index";

export const findGenusIndexByIndex = async (index) => {
    const {data} = await $host.get('genus-index/' + index)
    return data
}

export const findGenusIndexByGenus = async (genus) => {
    const {data} = await $host.get('genus-index/genus/' + genus)
    return data
}

export const createGenusIndex = async (index, genusList) => {
    const {data} = await $host.post('genus-index/', { index, genusList})
    return data
}

export const updateGenusIndex = async (index, genusList) => {
    const {data} = await $host.put('genus-index/', { index, genusList})
    return data
}

export const deleteGenusIndex = async (index) => {
    const {data} = await $host.delete('genus-index/' + index)
    return data
}